import React from 'react';

// Styles & Assets
import styles from './AdministrationOption.module.css';

// Interfaces
import { AdministrationButton } from '../../interfaces/Administration';

// Other
import { Link } from 'react-router-dom';

// AdministrationOption: renders a button of the SettingsAdministrationPage. Props:
//  -option: option with information to render the button
const AdministrationOption: React.FC<{
    option: AdministrationButton
}> = ({ option }) => {

    const classes = `${styles.container} ${option.disabled ? styles.disabled : ''}`;
    const target = option.target ? '_target' : '';

    return (
        <Link to={option.disabled ? '#' : option.link} target={target} className={classes}>
            <img src={option.logo} className={styles.logo} alt='administration logo' />
            <h2>{option.label}</h2>
        </Link>
    );
};

export default AdministrationOption;